import axios from 'axios';

import type { AxiosResponse } from 'axios';
import type {
  ConsolidatedInventoryConfig,
  InventorySource,
  InventorySyncConnection,
  UpdateConnectionRequest,
} from '../types/inventory-sync-types';

export const getConsolidatedInventorySources = async (): Promise<ConsolidatedInventoryConfig> => {
  const response = await axios.get<ConsolidatedInventoryConfig>('/consolidatedInventory/config');
  return response.data;
};

export const postExcludedInventorySources = async (excludedSourceIds: string[]): Promise<ConsolidatedInventoryConfig> => {
  const response = await axios.post<ConsolidatedInventoryConfig>('/consolidatedInventory/config', excludedSourceIds);
  return response.data;
};

export const getInventorySyncConnections = async (): Promise<InventorySyncConnection[]> => {
  const response = await axios.get<InventorySyncConnection[]>('/consolidatedInventory/connections');
  return response?.data ?? [];
};

export const updateInventorySyncConnections = async (
  updateConnectionRequests: UpdateConnectionRequest[],
): Promise<InventorySyncConnection[]> => {
  const response = await axios.post<InventorySyncConnection[]>('/consolidatedInventory/connections/update', {
    updateConnectionRequests,
  });
  return response?.data ?? [];
};

/**
 * Writes a `jobs` row and drops an SQS message, then returns — in milliseconds, with
 * `status: 'enqueued'`. Push jobs stay invisible to the worker for `MANUAL_PUSH_JOB_DELAY` seconds
 * (60 by default), and a trigger raised while a non-terminal job already exists returns that job
 * without enqueuing anything. Nothing here means a marketplace has been contacted.
 *
 * The whole response is returned because the legacy settings page decides between its success and
 * error notifications from `response.status`.
 */
export const triggerInventorySync = async (): Promise<AxiosResponse<unknown>> => {
  const response = await axios.post('/consolidatedInventory/inventory/sync');
  return response;
};

export const getInventorySources = async (includeAllOption = true): Promise<InventorySource[]> => {
  const response = await axios.get<InventorySource[]>(`/inventorysources?includeAllOption=${includeAllOption ? 'true' : 'false'}`);
  return response?.data ?? [];
};
